// components/ui/logo.jsx
import React from "react";
import Link from "next/link";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  wrapperClassName?: string;
  imageClassName?: string;
}

const Logo: React.FC<LogoProps> = ({
  className = "",
  wrapperClassName = "",
  imageClassName = "-ml-4.5 mt-4",
}) => {
  return (
    <div className={cn(``, wrapperClassName)}>
      <Link href="/" className={cn(`relative block w-full h-auto`, className)}>
        <img
          src="/layout/logo.svg"
          alt="Logo"
          width={500}
          height={250}
          fetchPriority="high"
          decoding="async"
          className={cn("w-full h-auto", imageClassName)}
        />
      </Link>
    </div>
  );
};

export default Logo;
